<template>
    <div class="conference-room h-100 mt-5">
        <div class="is-flex is-justify-content-center has-text-centered">
            <div class="column is-6">
                <div class="article-top-right has-background-primary p-4">
                    <img src="@/assets/images/user-video.png" width="80" />
                </div>
                <div class="article-content-right pt-3">
                    <p
                        v-if="!connected && seconds > 0"
                        class="title is-5 has-text-primary"
                    >
                        Se va a entrar en cola para llamadas en
                        {{ seconds }} segundos
                    </p>
                    <div v-if="operator !== null && hasSkills" class="mt-3">
                        <button
                            v-if="connected || seconds > 0"
                            class="button is-danger"
                            @click="disconectModal"
                        >
                            Desconectarse
                        </button>
                        <button
                            v-if="!connected && seconds === 0"
                            class="button is-primary"
                            @click="connect"
                        >
                            Conectarse
                        </button>
                    </div>
                    <div v-if="operator === null" class="mb-3 mt-3">
                        <p class="subtitle is-6 has-text-greyText">
                            Se esta cargando la información del operador ...
                        </p>
                    </div>
                    <div v-else class="mb-5 mt-3">
                        <p
                            v-if="!hasSkills"
                            class="subtitle is-6 has-text-greyText"
                        >
                            Por favor espere mientras el supervisor le asigna
                            trámites para realizar...
                        </p>
                        <p v-else class="subtitle is-6 has-text-greyText">
                            Por favor espere mientras se conecta un ciudadano
                            que requiera de sus servicios...
                        </p>
                    </div>
                    <OperatorInfo
                        v-if="operator !== null"
                        :operator="operator"
                    />
                </div>
            </div>
        </div>
        <DisconnectOperatorModal
            v-if="showCloseDisconnect"
            :userId="userId"
            @close="disconectModal"
            @closed="disconect"
        />
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import * as SignalR from "@microsoft/signalr";

import OperatorInfo from "@/components/operators/OperatorInfo.vue";
import DisconnectOperatorModal from "@/components/operators/DisconnectOperatorModal";

export default {
    name: "online-operator",
    components: {
        OperatorInfo,
        DisconnectOperatorModal,
    },
    data() {
        return {
            seconds: 10,
            countdownTimer: null,

            operator: null,
            signalRSocket: false,
            loading: false,
            connected: false,
            showCloseDisconnect: false,
            toRoom: false,
        };
    },
    async mounted() {
        if (!this.isOperator) {
            this.$router.push({
                name: "home",
            });
        }

        var operator = await this.getOperator();
        if (operator === null) {
            operator = await this.registerOperator();
        }
        this.operator = operator;

        await this.signalRInitialize();

        this.countdownTimer = setInterval(this.updateSeconds, 1000);
    },
    async beforeDestroy() {
        clearInterval(this.countdownTimer);
        this.signalRSocket.off("OperatorUpdated", this.operatorUpdated);
        this.signalRSocket.off("RoomAsigned", this.roomAsigned);

        if (this.toRoom === false && this.connected) {
            await this.signalRSocket.invoke(
                "OperatorLeave",
                this.userId,
                4,
                "Sesión desconectada"
            );
            window.console.log("Disconect!");
        }

        let socket = this.signalRSocket;
        this.signalRSocket = null;
        await socket.stop();
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
        userId() {
            return this.oidcUser.sub;
        },
        isOperator() {
            if (!this.oidcIsAuthenticated) {
                return false;
            }
            let roles = this.oidcUser?.role;
            return roles.indexOf("Operador") > -1;
        },
        hasSkills() {
            if (this.operator === null) {
                return false;
            }

            return this.operator.skills.length > 0;
        },
    },
    methods: {
        ...mapActions("oidcStore", ["authenticateOidc"]),
        updateSeconds() {
            this.seconds--;
            if (this.seconds === 0) {
                clearInterval(this.countdownTimer);
                this.connect();
            }
        },
        async connect() {
            await this.signalRSocket.invoke("OperatorJoin", this.userId);
            this.connected = true;
        },
        async disconectModal() {
            this.showCloseDisconnect = !this.showCloseDisconnect;
        },
        async disconect(disconnectionType, reason) {
            clearInterval(this.countdownTimer);
            this.seconds = 0;

            await this.signalRSocket.invoke(
                "OperatorLeave",
                this.userId,
                disconnectionType,
                reason
            );
            this.connected = false;
            this.disconectModal();

            this.$router.push({ name: "home" });
        },
        async getOperator() {
            try {
                let response = await RepositoryFactory.operators.get({
                    id: this.userId,
                });
                if (response.status === 204) {
                    return null;
                }
                let operator = response.data;
                return operator;
            } catch (error) {
                window.console.log(error);
            }
        },
        async registerOperator() {
            try {
                let payload = {
                    id: this.userId,
                };
                let response = await RepositoryFactory.operators.add(payload);
                let operator = response.data;
                return operator;
            } catch (error) {
                window.console.log(error);
            }
        },
        async operatorUpdated(userId) {
            if (this.operator.userId === userId) {
                var operator = await this.getOperator();
                this.operator = operator;
            }
        },
        async signalRInitialize() {
            try {
                const socket = new SignalR.HubConnectionBuilder()
                    .withUrl(process.env.VUE_APP_ONLINE_HUB)
                    .withAutomaticReconnect()
                    .build();

                socket.connection.onclose = async (error) => {
                    if (error !== undefined) {
                        this.$log(error);
                    }

                    if (this.signalRSocket !== null) {
                        this.$log("Reconnecting...");
                        this.signalRSocket = false;
                        await this.signalRInitialize();
                        await this.connect();
                    }
                };

                await socket.start();

                this.signalRSocket = socket;

                this.signalRSocket.on("OperatorUpdated", this.operatorUpdated);
                this.signalRSocket.on("RoomAsigned", this.roomAsigned);
            } catch (err) {
                this.$log("Error, reconnecting...");

                setTimeout(() => {
                    this.signalRInitialize();
                }, 1000);
            }
        },
        async roomAsigned(payload) {
            if (payload.operatorId === this.operator.userId) {
                this.toRoom = true;
                await this.signalRSocket.invoke("OperatorToRoom", payload);

                this.$router.push({
                    name: "room",
                    params: {
                        roomId: payload.roomId,
                    },
                    query: {
                        require_auth: true
                    }
                });
            }
        },
    },
};
</script>
